/* eslint-disable jsx-a11y/alt-text */
import React from 'react';
import Head from 'next/head';
import Header24 from '@/components/organisms/Header24';
import Footer24 from '@/components/organisms/Footer24';
import Styles from './EnergiaSolarPerguntasFrequentes.css';
import EnergiaSolarFaq from '@/components/organisms/EnergiaSolarFaq';
import EnergiaSolarFaqBanner from '@/components/organisms/EnergiaSolarFaqBanner';

function EnergiaSolarPerguntasFrequentes() {
  return (
    <>
      <Head>
        <title>FAQ Energia Solar | Santander Financiamentos</title>
        <meta
          name="Description"
          content="Nesta FAQ você encontra as respostas para suas perguntas sobre como aproveitar os benefícios da energia fotovoltaica com a Santander Financiamentos."
        />
        <meta name="robots" content="index,follow" />

        <link
          rel="canonical"
          href="https://www.santander.com.br/hotsite/santanderfinanciamentos/energia-solar-fotovoltaica-perguntas-frequentes.html"
        />
        {/* <!-- OPEN GRAPH TAGS FOR FACEBOOK, WHATSAPP AND LINKEDIN --> */}
        <meta property="og:locale" content="pt_BR" />
        <meta property="og:title" content="FAQ Energia Solar | Santander Financiamentos" />
        <meta
          property="og:url"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/energia-solar-fotovoltaica-perguntas-frequentes.html"
        />
        <meta property="og:site_name" content="Santander Financiamentos" />
        <meta
          property="og:description"
          content="Nesta FAQ você encontra as respostas para suas perguntas sobre como aproveitar os benefícios da energia fotovoltaica com a Santander Financiamentos."
        />
        <meta
          property="og:image"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/assets/energia-solar/hero/banner-800.webp"
        />
        <meta
          property="og:image:alt"
          content="Casa moderna com painéis solares no telhado com Sol brilhando, cercada por um jardim vibrante com muitas plantas e árvores."
        />
        <meta property="og:image:type" content="image/png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="627" />
        <meta property="og:type" content="website" />

        {/* <!-- TWITTER CARDS FOR TWITTER --> */}
        <meta name="twitter:card" content="" />
        <meta name="twitter:title" content="FAQ Energia Solar | Santander Financiamentos" />
        <meta
          name="twitter:description"
          content="Nesta FAQ você encontra as respostas para suas perguntas sobre como aproveitar os benefícios da energia fotovoltaica com a Santander Financiamentos."
        />
        <meta
          name="twitter:url"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/energia-solar-fotovoltaica-perguntas-frequentes.html"
        />
        <meta
          property="twitter:image"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/assets/energia-solar/hero/banner-800.webp"
        />
        <meta
          property="twitter:image:alt"
          content="Casa moderna com painéis solares no telhado com Sol brilhando, cercada por um jardim vibrante com muitas plantas e árvores."
        />
        <meta property="twitter:image:type" content="image/png" />
        <meta property="twitter:image:width" content="1200" />
        <meta property="twitter:image:height" content="627" />
      </Head>
      <Header24 isHome24 />
      <EnergiaSolarFaqBanner />
      <EnergiaSolarFaq />
      <Footer24 />
      <style jsx>{Styles}</style>
    </>
  );
}

export default EnergiaSolarPerguntasFrequentes;
